<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="2" :offset="22">
						<el-form-item>
							<el-button type="warning" size="mini" @click="toSignatureAdd">添加印章</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="tableBox">
			<div class="table">
				<div class="tableItem" v-for="(item,index) in tableData" :key="index" @click="toDetail(item)">
					<img class="img" :src="item.sealUrl">
					<div class="tableItemName">{{item.sealName}}</div>
				</div>
			</div>
			<page style="padding:10px 0;" :total="page.total" :page="page.page" :pageSize="page.pageSize"  @change="changePage"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				page:{
					page:1,
					pageSize:24,
					total:0
				},
				tableData:[],
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			toSignatureAdd(){
				this.$router.push({path:"/signature/signatureAdd"})
			},
			toDetail(item){
				this.$router.push({path:"/signature/signatureSee?id="+item.id})
			},
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"sealType": 0, // 类型
					"sealState": 0,  // 状态
					"shopId": this.curShopId,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": ""
				}
				let loading=this.$loading();
				this.$http.post('/api/Contract/Seal/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	.searchBox {
		.el-form-item {
			margin-bottom: 0;
		}
	}
	.tableBox{
		padding:20px;background-color: #fff;min-height: 600px;margin-top:12px;
		.table{
			display: flex;flex-wrap: wrap;
			.tableItem{
				width:185px;height: 227px;background-color: #fff;border:1px solid #e4e4e4;text-align: center;margin-right: 10px;cursor: pointer;
				.img{
					width:150px;height: 150px;padding-top:25px;padding-bottom: 16px;
				}
				.tableItemName{
					width:100%;line-height: 34px;background-color: #e4e4e4;text-align: center;color:#2A2A2A;font-size: 14px;font-weight: bold;
				}
			}
		}
	}
}
</style>
